import { useContext } from "@wordpress/element";
import { SettingsContext } from "../context/SettingsContext";

export const useSettingsContext = () => {
    const context = useContext(SettingsContext);

    if (!context) {
        throw new Error(
            "useSettingsContext must be used within a SettingsContextProvider. " +
                "Make sure your component is wrapped with <SettingsContextProvider>."
        );
    }

    return context;
};
